<template>
  <span>
    <span @click="open">
      <slot name="activator"></slot>
    </span>
    <transition name="slide-fade">
      <div v-if="show" class="modal-placeholder" @click="close">
        <div class="modal-bg" @click.stop>
          <i class="close icon" @click="close"></i>
          <div class="header">
            <h2>
              <slot name="header"></slot>
            </h2>
          </div>
          <div class="toolbar">
            <slot name="toolbar"></slot>
          </div>
          <div class="content">
            <slot></slot>
          </div>
        </div>
      </div>
    </transition>
  </span>
</template>

<style scoped>
.modal-placeholder {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 3;
  height: 100%;
}

.modal-bg {
  position: fixed;
  left: 100px;
  right: 0;
  top: 0;
  height: 100%;
  background-color: #fff;
  padding: 20px 10px;
  overflow: auto;
}

.close {
  position: absolute;
  right: 20px;
  font-size: 22px;
  color: #777;
}

.toolbar {
  padding: 10px 0;
}

.content {
  height: calc(100% - 90px);
  overflow: auto;
}

.slide-fade-enter-active {
  transition: all 0.2s ease;
}

.slide-fade-leave-active {
  transition: all 0.2s ease;
}

.slide-fade-enter,
.slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-700px);
}
</style>

<script>
export default {
  name: 'Modal',
  data() {
    return {
      show: false
    }
  },
  computed: {},
  mounted() {},
  methods: {
    open() {
      this.$emit('before-open')
      this.show = true
    },
    close() {
      this.$emit('before-close')
      this.show = false
      this.$emit('close')
    }
  }
}
</script>



// WEBPACK FOOTER //
// Modal.vue?df3f87f6